import { Outlet, Link } from "react-router-dom";

export const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
